<template>
  <v-card v-if="payload.composite">
    <v-toolbar dark color="primary">
      <v-toolbar-title>Ajouter des matériaux</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn theme="dark" variant="text" @click.stop="cancel">Annuler</v-btn>
        <v-btn theme="dark" variant="text" @click.stop="confirm">Confirmer</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text class="pt-0">
      <v-container fluid class="pt-2">
        <v-row class="justify-end" v-if="!isUserAdmin">
          <v-btn variant="text" color="grey" @click="showCustomMaterialDialog()" class="pr-0">
            Créer un matériau
            <v-icon end class="pr-1" color="secondary" size="24">mdi-plus-circle</v-icon>
          </v-btn>
        </v-row>
        <v-row class="mb-3">
          <v-col cols="12">
            <p class="text-primary font-weight-medium mb-0">Matériau(x) sélectionné(s)</p>
            <div v-if="!hasSelectedMaterials">Aucun</div>
            <div v-else class="d-flex flex-wrap ga-2">
              <v-chip
                v-for="(material, index) in allSelectedMaterials"
                :key="index"
                closable
                @update:model-value="deSelectMaterial(material)"
              >
                {{ material.materialName || material.name }}
              </v-chip>
            </div>
          </v-col>
        </v-row>

        <v-tabs v-model="activeTab" bg-color="primary" color="white" class="mt-2">
          <v-tab class="text-white"> Assemblage </v-tab>
          <v-tab class="text-white"> Catalogue </v-tab>
          <v-tab class="text-white" v-if="!isUserAdmin"> Personnalisés </v-tab>
        </v-tabs>
        <v-tabs-window v-model="activeTab">
          <v-tabs-window-item>
            <composite-list
              :materialToDeselect="materialToDeselected"
              :allSelectedMaterials="allSelectedMaterials"
              :composite="payload.composite"
              :activeTab="activeTab"
              @add-material="addMaterial"
              @remove-material="removeMaterial"
            ></composite-list>
          </v-tabs-window-item>
          <v-tabs-window-item>
            <CatalogList
              :materialToDeselect="materialToDeselected"
              :activeTab="activeTab"
              :allSelectedMaterials="allSelectedMaterials"
              @add-catalog-material="addMaterial"
              @remove-catalog-material="removeMaterial"
            ></CatalogList>
          </v-tabs-window-item>
          <v-tabs-window-item v-if="!isUserAdmin">
            <custom-material-list
              :forceFetch="dialogCustomMaterial"
              :materialToDeselect="materialToDeselected"
              :allSelectedMaterials="allSelectedMaterials"
              :activeTab="activeTab"
              @add-material="addMaterial"
              @remove-material="removeMaterial"
            >
            </custom-material-list>
          </v-tabs-window-item>
        </v-tabs-window>
      </v-container>
    </v-card-text>
    <modal-custom-material
      :show="dialogCustomMaterial"
      :mode="'add'"
      @close="closeCustomMaterialDialog"
    ></modal-custom-material>
  </v-card>
</template>

<script>
import { DialogPropsMixin } from '@/components/dialog/mixins';
import { AddMaterial } from '@/_services/jobs';
import ModalCustomMaterial from '@/components/material/ModalCustomMaterial.vue';
import CompositeList from '@/components/job/stepper/steps/phases/CompositeList.vue';
import CustomMaterialList from '@/components/job/stepper/steps/phases/CustomMaterialList.vue';
import CatalogList from '@/components/job/stepper/steps/phases/CatalogList.vue';
import { stepperMixin } from '@/classes/helper/stepperHelper';

export default {
  name: 'MaterialAddDialog',
  components: {
    CatalogList,
    CustomMaterialList,
    CompositeList,
    ModalCustomMaterial,
  },
  mixins: [DialogPropsMixin, stepperMixin],
  data() {
    return {
      activeTab: 0,
      allSelectedMaterials: [],
      catalogName: 'catalog',
      compositeName: 'composite',
      customName: 'custom',
      dialogCustomMaterial: false,
      materialToDeselected: {},
      types: {
        catalog: 'CATALOGUE',
        assemblage: 'ASSEMBLAGE',
      },
    };
  },
  methods: {
    confirm() {
      this.$emit('loading');

      let fromServer = this.allSelectedMaterials.filter(x => x.type !== undefined);
      let fromLocal = this.allSelectedMaterials.filter(x => x.type === undefined);

      // Map de la structure innitial avec les matériaux ajouté localement
      let compositeMaterialPrototypes = {
        compositeMaterialPrototypes: fromLocal
          .filter(x => x.compositeMaterialPrototypeId === undefined)
          .map(x => ({
            compositePrototype: this.payload.composite.compositePrototypeId,
            materialPrototype: x.id,
          })),
        compositeMaterialPrototypeIds: fromLocal
          .filter(x => x.compositeMaterialPrototypeId !== undefined)
          .map(x => x.compositeMaterialPrototypeId),
      };
      // Ajouter les items venant du serveur ayant le type Catalog dans les matériaux de catalog local.
      compositeMaterialPrototypes.compositeMaterialPrototypes.push(
        ...fromServer
          .filter(x => x.type === this.types.catalog)
          .map(x => ({
            compositePrototype: this.payload.composite.compositePrototypeId,
            materialPrototype: x.materialPrototypeId,
          })),
      );
      // Ajout des id des matériaux ayant le type Assemblage dans les matériaux d'assemblage local.
      compositeMaterialPrototypes.compositeMaterialPrototypeIds.push(
        ...fromServer.filter(x => x.type === this.types.assemblage).map(x => x.compositeMaterialPrototypeId),
      );
      // Envoie de la requête
      AddMaterial(this.payload.composite.id, compositeMaterialPrototypes)
        .then(composite => {
          this.$store.dispatch('job/updateComposite', {
            composite: composite,
            compositeId: composite.id,
            phaseId: this.payload.phaseId,
          });
        })
        .catch(error => {
          this.$store.dispatch('snackbar/set', error);
        })
        .finally(() => {
          this.updateTotalCost(this.$store.getters['submission/getJobId'])
            .catch(error => {
              this.$store.dispatch('snackbar/set', error);
            })
            .finally(() => {
              this.$emit('loading', false);
              this.$emit('close');
            });
        });

      this.resetData();
    },
    cancel() {
      this.resetData();
      this.$emit('close');
    },
    deSelectMaterial(material) {
      this.materialToDeselected = material;
      this.allSelectedMaterials = this.allSelectedMaterials.filter(
        x => x.id !== material.id || x.compositeMaterialPrototypeId !== material.compositeMaterialPrototypeId,
      );
    },
    closeCustomMaterialDialog() {
      this.dialogCustomMaterial = false;
    },
    showCustomMaterialDialog() {
      this.dialogCustomMaterial = true;
    },
    addMaterial(materialObj) {
      this.allSelectedMaterials = [...this.allSelectedMaterials, materialObj.material];
    },
    removeMaterial(materialObj) {
      if (materialObj.type === this.compositeName) {
        this.allSelectedMaterials = this.allSelectedMaterials.filter(
          x => x.compositeMaterialPrototypeId !== materialObj.material.compositeMaterialPrototypeId,
        );
      }
      if (materialObj.type === this.catalogName) {
        this.allSelectedMaterials = this.allSelectedMaterials.filter(x => x.id !== materialObj.material.id);
      }
      if (materialObj.type === this.customName) {
        this.allSelectedMaterials = this.allSelectedMaterials.filter(x => x.id !== materialObj.material.id);
      }
    },
    resetData() {
      this.allSelectedMaterials = [];
      this.activeTab = 0;
    },
  },
  computed: {
    isUserAdmin() {
      return this.$store.getters['user/isAdmin'];
    },
    hasSelectedMaterials() {
      return this.allSelectedMaterials.length > 0;
    },
  },
  mounted() {
    this.allSelectedMaterials = this.payload.composite.materials;
  },
};
</script>
